import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Webinar name",
  "user name",
  "Webinar Date",
  "Actions",
];

const ViewWebinarChatTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id, userName) => {
    navigate(`/view-webinar-chats/${id}?username=${userName}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.webinarName || "N/A"}</td>
                <td>{item?.userName || "N/A"}</td>
                <td>{item?.webinarDate || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.webinarId, item?.userName)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ViewWebinarChatTable;
